const chapterEls = document.querySelectorAll(".js-chapter-section");

const navButtons = document.querySelectorAll(".js-nav-el");

const scrollButtonUp = document.querySelector(".js-nav-up");

const scrollButtonDown = document.querySelector(".js-nav-down");

let activeChapter = 0;

const finalChap = chapterEls.length;

const scrollNav = document.querySelector(".js-scroll-nav");

//helper funcs

function removeActiveClasses() {
    let activeButtons = document.querySelectorAll(".nav-is-active");

    [].forEach.call(activeButtons, function (el) {
        el.classList.remove("nav-is-active");
    });
}

function scrollToChap(assocChap) {
    gsap.to(window, {
        duration: 0.6,

        ease: "power4.easeInOut",

        scrollTo: assocChap
    });
}

function disableScrollBtn() {
    if (typeof scrollButtonUp != "undefined" && scrollButtonUp != null) {
        if (activeChapter <= 1) {
            scrollButtonUp.classList.add("disabled");
        } else {
            scrollButtonUp.classList.remove("disabled");
        }
    }

    if (typeof scrollButtonDown != "undefined" && scrollButtonDown != null) {
        if (activeChapter >= finalChap) {
            scrollButtonDown.classList.add("disabled");
        } else {
            scrollButtonDown.classList.remove("disabled");
        }
    }
}

function updateOnScrollBtn() {
    //active classes

    removeActiveClasses();

    const currButton = Array.from(navButtons).filter(
        (button) => parseInt(button.dataset.num) + 1 == activeChapter
    );

    currButton[0].classList.add("nav-is-active");

    //scroll

    const assocChap = document.querySelector(
        `.js-chapter-section-${activeChapter}`
    );

    scrollToChap(assocChap);

    //disable scrollbuttons

    disableScrollBtn();
}

if (typeof navButtons != "undefined" && navButtons != null) {
    navButtons.forEach((button) => {
        const buttonNum = parseInt(button.dataset.num) + 1;

        const assocChap = document.querySelector(
            `.js-chapter-section-${buttonNum}`
        );

        button.addEventListener("click", (e) => {
            e.preventDefault();

            removeActiveClasses();

            button.classList.add("nav-is-active");

            //update active chapter

            activeChapter = buttonNum;

            disableScrollBtn();

            //scroll to section

            scrollToChap(assocChap);
        });
    });
}

if (typeof scrollButtonUp != "undefined" && scrollButtonUp != null) {
    scrollButtonUp.addEventListener("click", () => {
        if (activeChapter > 1) {
            activeChapter--;

            updateOnScrollBtn();
        }
    });
}

if (typeof scrollButtonDown != "undefined" && scrollButtonDown != null) {
    let clickAmount = 0;
    scrollButtonDown.addEventListener("click", () => {
        if (clickAmount == 0 && activeChapter == 12) {
            activeChapter = 0;
        }  
        if (activeChapter < finalChap) {
            activeChapter++;

            updateOnScrollBtn();
        }
        clickAmount++;
    });
}

///update on scroll

var locationArray = [];
var locationArrayLength = "";

function checkPosition() {
    var halfHeight = window.innerHeight / 2;
    var viewportTop = window.pageYOffset;
    var viewportBottom = viewportTop + window.innerHeight;

    for (var i = 0; i < locationArrayLength; i++) {
        var elementNo = locationArray[i][0];
        var elem =  document.querySelector(
            `.js-chapter-section-${elementNo}`
        );

        if (
            locationArray[i][1] < viewportBottom - halfHeight &&
            locationArray[i][2] > viewportTop + halfHeight
        ) {

            activeChapter = elem.dataset.num;
            
            let currButton = Array.from(navButtons).filter(
                (button) =>
                    parseInt(button.dataset.num) + 1 == parseInt(activeChapter)
            );

            removeActiveClasses();

            currButton[0].classList.add("nav-is-active");

            disableScrollBtn();
        }
    }
}

function checkScroll() {
    chapterEls.forEach((chapter) => {
        activeChapter = chapter.dataset.num;
        var elemTop = Math.round(chapter.offsetTop);
        var elemBottom = elemTop + chapter.offsetHeight;

        locationArray.push([activeChapter, elemTop, elemBottom]);
        locationArrayLength = locationArray.length;
    });
}

if (typeof scrollNav != "undefined" && scrollNav != null) {
    checkScroll();
    
    window.addEventListener("scroll", () => {
        checkPosition();
    });
}
